import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './index.css';
import App from './Home'; // Componente principal
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

// ── Sentry — monitoreo de errores y performance ───────────────────────────────
// Solo se activa si REACT_APP_SENTRY_DSN está configurada (dev sin clave = sin tracking)
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance: 10 % de transacciones (amigable con el plan gratuito)
    tracesSampleRate: 0.1,
    // Session Replay: 5 % de sesiones normales, 100 % de sesiones con error
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    // No enviar datos PII (IPs, emails) automáticamente
    sendDefaultPii: false,
  });
}
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Registro del Service Worker (IMPORTANTE para segundo plano)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
      })
      .catch((err) => {
        console.error('Error registrando el Service Worker de Firebase:', err);
      });
  });
}

// serviceWorkerRegistration.register({
//   onUpdate: async (registration) => {
//     // Corremos este código si hay una nueva versión de nuestra app
//     // Detalles en: https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle
//     if (registration && registration.waiting) {
//       await registration.unregister();
//       registration.waiting.postMessage({ type: "SKIP_WAITING" });
//       // Des-registramos el SW para recargar la página y obtener la nueva versión. Lo cual permite que el navegador descargue lo nuevo y que invalida la cache que tenía previamente.
//       window.location.reload();
//     }
//   },
// });


reportWebVitals();
//serviceWorkerRegistration.register();